import {
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_PROMO_PRODUCT_LIST,
  PT_PRODUCT_LIST,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  DIFERENCE_MINUTES,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  GET_SELECTED_MERCHANT_OR_PRODCUCT,
  GET_SET_STORED_DATA,
  GET_CART,
} from "../../database/get-stored-data";
import {
  set_dto_selected_merchant_or_product,
  set_dto_MobileAppCategory,
} from "../../classes/dto-setters/dto-setter";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  CSP,
} from "../../config/config";
import {
  Api_DrawAnalyticalPath,
  api_DaitonnAnalytical,
} from "../../connection/api/api-Machine-Learning";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_common } from "../../classes/dto-common";
import { isMobile } from "react-device-detect";
import { Font } from "../../util/config-fonts";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import CatPlaceholder from "./components/category-placeloader/Category-placeLoader";
import SummaryCart from "../../components/render-drawer-summary-cart/render-drawer-summary-cart";
import React from "react";
import "../../styles/css/fixedbutton.css";
import QuickCartButton from "./components/quick-cart-button/quick-cart-button";

export default class MasterCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsLoading: false,
      Category: [],
      IsSummaryCart: false,
      LocalCart: [],
    };
    this.keepCheckInterval = null;
    this.lastCartSignature = "";
  }

  getCartSignature = (cart = []) =>
    cart
      .map(
        (item) =>
          `${item.PID}:${item.LineID}:${item.ADDONLINEID}:${item.Qty}:${item.UP}`,
      )
      .join("|");

  refreshLocalCart = async () => {
    let cart = await GET_CART();
    if (cart === undefined) {
      cart = [];
    }

    const nextSignature = this.getCartSignature(cart);
    if (nextSignature !== this.lastCartSignature) {
      this.lastCartSignature = nextSignature;
      this.setState({ LocalCart: cart });
    }
  };

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Category",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_HOME);
      },
      HeaderNavigatorMenuDisplay: true,
      FnHeaderNavigatorMenu: () => {
        this.props.navigate(
          PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "category"),
        );
      },
    });
    await this.LoadMasterCategory();
    let cart = await GET_CART();
    if (cart !== undefined) {
      this.setState({ LocalCart: cart });
      this.lastCartSignature = this.getCartSignature(cart);
    }
    this.keepCheckInterval = setInterval(() => {
      this.refreshLocalCart();
    }, 750);
  }

  async keepCheck() {
    await this.refreshLocalCart();
  }

  async componentWillUnmount() {
    clearInterval(this.keepCheckInterval);
  }

  async LoadMasterCategory() {
    this.setState({ IsLoading: true });
    let dataStorage = ENCRYPT_STORAGE.getItem("MasterCategory");
    let data = "";
    if (
      dataStorage !== undefined &&
      dataStorage !== "" &&
      dataStorage.MID === dto_selected_merchant_or_product.MID
    ) {
      let StorageDateTime = new Date(dataStorage.date);
      let currentDateTime = new Date();
      let DifferenceMinute = DIFERENCE_MINUTES(
        currentDateTime,
        StorageDateTime,
      );
      if (DifferenceMinute > 5) {
        data = await api_CategoryPageLoadGroceryCategory();
        ENCRYPT_STORAGE.setItem("MasterCategory", {
          data: data,
          date: new Date(),
          MID: dto_selected_merchant_or_product.MID,
        });
      } else {
        data = dataStorage.data;
      }
    } else {
      data = await api_CategoryPageLoadGroceryCategory();
      ENCRYPT_STORAGE.setItem("MasterCategory", {
        data: data,
        date: new Date(),
        MID: dto_selected_merchant_or_product.MID,
      });
    }

    let objData = JSON.parse(data);
    let Localcart = await GET_CART();
    if (Localcart === undefined) {
      Localcart = [];
    }
    setTimeout(() => {
      this.setState({
        IsLoading: false,
        Category: objData,
        LocalCart: Localcart,
      });
    }, 300);
    await api_DaitonnAnalytical();
  }

  getTotalPrice() {
    const total = this.state.LocalCart.reduce(
      (sum, item) => sum + item.Qty * item.UP,
      0,
    );
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${dto_StartupPageLoadInfo.Currency} ${formattedTotal}`;
  }

  render() {
    return (
      <div
        style={{
          marginTop: 55,
          marginBottom: 55,
        }}
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <>
          {this.state.IsLoading ? (
            <CatPlaceholder />
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginLeft: "10px",
                }}
              >
                {this.state.Category.map((item) => {
                  if (
                    item.CategoryImageUrl === "" ||
                    item.CategoryImageUrl === "N/A"
                  ) {
                    // item.CategoryImageUrl = "https://www.daitonnmail.com/images/DAITONN/1_1/MKB/PRODUCTS/MKBNull.png";
                    item.CategoryImageUrl = dto_common.DefaultImageUrl;
                  }
                  return (
                    <div
                      style={{
                        width: "33.33%",
                        padding: "0 4px",
                        cursor: "pointer",
                      }}
                      key={item.CATID + "MACCATE"}
                      onClick={() => {
                        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                        this.NavigateToProduct(item);
                        set_dto_MobileAppCategory(item);
                      }}
                    >
                      <div style={{ padding: "2px" }}>
                        <img
                          src={item.CategoryImageUrl}
                          style={{ height: 100, width: 100 }}
                          onError={(e) => {
                            // e.currentTarget.src = "https://www.daitonnmail.com/images/DAITONN/1_1/MKB/PRODUCTS/MKBNull.png";
                            e.currentTarget.src = dto_common.DefaultImageUrl;
                          }}
                          alt=""
                        />
                        <p
                          style={{
                            width: 90,
                            fontSize: Font.Description,
                            marginTop: 0,
                          }}
                        >
                          {item.Category}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </>

        {this.state.LocalCart.length > 0 ? (
          <QuickCartButton
            totalPrice={this.getTotalPrice()}
            itemCount={this.state.LocalCart.length}
            onClick={async () => {
              let Localcart = await GET_CART();
              if (Localcart === undefined) {
                Localcart = [];
              }
              this.setState(
                { IsSummaryCart: true, LocalCart: Localcart },
                async () => {
                  await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
                    let Localcart = await GET_CART();
                    if (Localcart === undefined) {
                      Localcart = [];
                    }
                    this.setState({
                      IsSummaryCart: false,
                      LocalCart: Localcart,
                    });
                  });
                },
              );
            }}
          />
        ) : null}

        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0),
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({
                  LocalCart: updatedCart,
                  IsSummaryCart: updatedCart.length > 0,
                });
              }}
              closeFunction={() => this.setState({ IsSummaryCart: false })}
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />
      </div>
    );
  }

  async NavigateToProduct(data) {
    await Api_DrawAnalyticalPath(7, data.CATID);
    let rs = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
    rs.CATID = data.CATID;
    await set_dto_selected_merchant_or_product(rs);
    dto_selected_merchant_or_product.CATID = data.CATID;
    if (dto_selected_merchant_or_product.MT === "AF") {
      dto_selected_merchant_or_product.MT = "AF";
    } else {
      dto_selected_merchant_or_product.MT = "GR";
    }

    if (
      data.CATID === 1 &&
      data.MACID === 1 &&
      data.Category === "OFFER" &&
      CSP === "MK"
    ) {
      this.props.navigate(PT_PROMO_PRODUCT_LIST.replace(":navPage", "none"));
    } else {
      this.props.navigate(
        PT_PRODUCT_LIST.replace(":navPage", "none").replace(":isSec", "false"),
      );
    }
  }
}
